import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../../../utils/Custom/text";
import CommonForm from "../../../../utils/commonComponent/commonForm";
import { CancelButton, SaveAndUpdate } from "../../../../utils/Custom/Button";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../../global";
import { getPermissions } from "../../../Pages/rbac/hasAccess";
import { validateRequiredFields } from "../../../../utils/commonComponent/errorAlert";



export const stageStatuses = [
  { id: 1, name: "Joined" },
  { id: 2, name: "Selected" },
  { id: 3, name: "Rejected" },
  { id: 4, name: "Backout" },
  { id: 5, name: "Shortlisted" },
  { id: 6, name: "Scheduled" },
];

const EditInterviewSchedule = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();

  const [inputStates, setInputStates] = React.useState({
    status: 1,
    interviewDate: new Date().toISOString().split("T")[0],
    scoreCardSubmited: "No",
  });

  const [pipelines, setPipelines] = React.useState([]);
  const [pipelinesRaw, setPipelinesRaw] = React.useState([]);
  const [modeOptions, setModeOptions] = React.useState([]);

  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({ ...prev, [key]: value }));
  };

  const fetchNextSchedId = async () => {
    try {
      const [last] = await fetchQuery(
        `SELECT SchedId FROM talentAcqInterview ORDER BY id DESC LIMIT 1`
      );
      const lastId = parseInt(
        last?.SchedId?.match(/\d+$/)?.[0] || "0",
        10
      );
      const nextId = `INT-${String(lastId + 1).padStart(3, "0")}`;
      updateInputObject("SchedId", nextId);
    } catch (error) {
      console.error("Error fetching last Sched ID:", error);
      updateInputObject("SchedId", "INT-001");
    }
  };

  const fetchDropdownOptions = async () => {
    try {
      const [pipelineList, masterList] = await Promise.all([
        fetchQuery(
          `SELECT p.id, p.pipelineId as plCode, c.candidateName, p.position, p.client, p.mode, p.interviewer 
           FROM talentAcqPipeline p 
           LEFT JOIN talentAcqCandidate c ON p.candId = c.id 
           WHERE p.status = 1`
        ),
        fetchQuery("SELECT id, type, Value FROM talentAcquisitionMaster WHERE status = 1 AND type = 7")
      ]);

      const list = masterList || [];
      setModeOptions(list.map((m) => ({ id: m.id, name: m.Value })));

      setPipelinesRaw(pipelineList || []);
      setPipelines(
        (pipelineList || []).map((p) => ({
          id: p.id,
          name: p.plCode,
        }))
      );
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    }
  };

  const fetchDetails = async () => {
    try {
      const [record] = await fetchQuery(
        `SELECT * FROM talentAcqInterview WHERE id = ${params.id}`
      );
      if (record) {
        if (record.interviewDate) record.interviewDate = record.interviewDate.split("T")[0];
        if (record.cvSharedDate) record.cvSharedDate = record.cvSharedDate.split("T")[0];
        setInputStates(record);
      }
    } catch (error) {
      console.error("Error fetching interview schedule data:", error);
    }
  };

  const onSubmit = async () => {
    const fieldsToValidate = [
      { value: inputStates.SchedId, label: "Sched ID is required" },
      { value: inputStates.pipelineId, label: "Pipeline ID is required" },
      { value: inputStates.interviewDate, label: "Interview Date is required" },
      { value: inputStates.interviewTime, label: "Interview Time is required" },
    ];

    if (!validateRequiredFields(fieldsToValidate)) return;

    try {
      const url = BASE_URL + `talentAcqInterview`;
      params.id != 0
        ? await axiosWithToken.patch(`${url}/${params.id}`, inputStates)
        : await axiosWithToken.post(url, inputStates);

      toast.success(
        params.id != 0 ? "Schedule Updated Successfully!" : "Schedule Created Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/talent-acquisition/interview-schedules"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  useEffect(() => {
    fetchDropdownOptions();
    if (params.id == 0) fetchNextSchedId();
  }, []);

  useEffect(() => {
    if (params.id != 0) fetchDetails();
  }, [params]);

  
  useEffect(() => {
    if (inputStates.pipelineId) {
      const pipeObj = pipelinesRaw.find((p) => p.id == inputStates.pipelineId);
      if (pipeObj) {
        if (
          inputStates.candidateName !== pipeObj.candidateName ||
          inputStates.position !== pipeObj.position ||
          inputStates.client !== pipeObj.client ||
          inputStates.mode !== pipeObj.mode ||
          inputStates.Interviewer !== pipeObj.interviewer
        ) {
          setInputStates((prev) => ({
            ...prev,
            candidateName: pipeObj.candidateName || "",
            position: pipeObj.position || "",
            client: pipeObj.client || "",
            mode: pipeObj.mode || "",
            Interviewer: pipeObj.interviewer || "",
          }));
        }
      }
    }
  }, [inputStates.pipelineId, pipelinesRaw]);

  const inputFields = [
    {
      type: "TextField",
      label: "Sched ID *",
      stateKey: "SchedId",
      disabled: true,
    },
    {
      type: "Autocomplete",
      label: "Pipeline *",
      stateKey: "pipelineId",
      options: pipelines,
      valueKey: "id",
      getOptionLabelKey: "name",
    },
    {
      type: "TextField",
      label: "Candidate Name",
      stateKey: "candidateName",
      disabled: true,
    },
    {
      type: "TextField",
      label: "Position",
      stateKey: "position",
      disabled: true,
    },
    {
      type: "TextField",
      label: "Client",
      stateKey: "client",
      disabled: true,
    },
    {
      type: "TextField",
      label: "Round No.",
      stateKey: "round",
      inputType: "number",
    },
    {
      type: "DatePicker",
      label: "Interview Date *",
      stateKey: "interviewDate",
    },
    {
      type: "TextField",
      label: "Interview Time *",
      stateKey: "interviewTime",
    },
    {
      type: "Autocomplete",
      label: "Mode",
      stateKey: "mode",
      options: modeOptions,
      valueKey: "id",
      getOptionLabelKey: "name",
    },
    {
      type: "Autocomplete",
      label: "Interviewer",
      stateKey: "Interviewer",
      options: "employees",
      valueKey: "name",
      getOptionLabelKey: "name",
    },
    {
      type: "DatePicker",
      label: "CV Shared Date",
      stateKey: "cvSharedDate",
    },
    {
      type: "Autocomplete",
      label: "Scorecard Submitted?",
      stateKey: "scoreCardSubmited",
      options: [
        { id: "No", name: "No" },
        { id: "Yes", name: "Yes" },
      ],
      valueKey: "id",
      getOptionLabelKey: "name",
    },
    {
      type: "Autocomplete",
      label: "Interview Status",
      stateKey: "interviewStatus",
      options: stageStatuses,
      valueKey: "id",
      getOptionLabelKey: "name",
    },
    {
      type: "Textarea",
      label: "Notes",
      stateKey: "notes",
    },
  ];

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create Interview Schedule" : "Update Interview Schedule"}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-save"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditInterviewSchedule;
